export function printDashboard(name, startDate, endDate) {
  const token = localStorage.getItem("token");

  const reports = {
    ingrediente: () => ingredientes(token, name, startDate, endDate),
    cultura: () => culturas(token, name, startDate, endDate),
  }

  reports[name]()
}

async function ingredientes(token, name, startDate, endDate) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales/dashboard/print?auth=${token}&type=${name}&startDate=${startDate}&endDate=${endDate}`
  );
}
async function culturas(token, name, startDate, endDate) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales/dashboard/print?auth=${token}&type=${name}&startDate=${startDate}&endDate=${endDate}`
  );
}
